import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { getPODPdf, PdfResultModel} from "@WhiteCap/Store/Service/PODService";

export interface getPODPdfApiParameter extends ApiParameter {
    orderNumber: string;
    isWillCall?: boolean;
    onSuccess?: () => void;
    onError?: (message: string) => void;
}
type HandlerType = CustomApiHandler<getPODPdfApiParameter, PdfResultModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};
export const RequestDataFromApi: HandlerType = async props => {
    const result = await getPODPdf(props?.apiParameter?.orderNumber, props.apiParameter.isWillCall ?? false);
    if (!result.successful) {
        props.parameter.onError?.(result?.errorMessage);
        return false;
    }
    if (result.result) {
        props.apiResult = result;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.result) {
        const blob = new Blob([props.apiResult.result], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `POD-${props.apiParameter.orderNumber}.pdf`);
        link.click();

        setTimeout(() => {
            window.URL.revokeObjectURL(url);
        }, 100);

        if (props.parameter?.onSuccess) {
            props.parameter.onSuccess();
        }
    }
};
export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const getPodPdf = createHandlerChainRunner(chain, "GetPodPdf");
export default getPodPdf;
